/**
 * Created by Mark on 24/04/2017.
 */


import React from "react";
import { FormattedMessage } from 'react-intl';
import LineGraph from '../../graphs/base/LineGraph.js';
import AssignStudents from '../../wizard/create-class-steps/add-students.js';
import {Modal , Panel , Table , Col , Row , ButtonToolbar , Button , OverlayTrigger , Tooltip} from 'react-bootstrap'
import StudentServices from '../../../services/student-services.js';
import StudentStores from '../../../store/student-store.js';
import Download from "../../../classes/download.js";
import ClassesService from "../../../services/classes-service.js";
import AuthneticationStore from "../../../store/authentication-store.js";
import StudentEdit from '../../forms/student-form.js';
import { Link } from 'react-router'
import GeneratePDF from '../../../classes/pdf_generate.js';
import ClassStore from '../../../store/classes-store.js';

class AboutPanel extends React.Component {

    constructor(){
        super();
        this.data = {

        };

        this.state ={
            students:[],
            isList:true,
            showModal:false,
            studentID:null,
            editUser:false,
            classInformation: undefined
        }

        //this.props.data.students = [];
        this.PDFgen = new GeneratePDF();
    }

    close(){
        this.setState({showModal:false});
    }

    showComfirmation(studentID){
        this.setState({showModal:true , studentID:studentID});
    }

    removeStudent(){
        ClassesService.removeUser(this.props.data.classID , this.state.studentID).then(function(){
            StudentServices.getAllStudentsInClass(this.props.data.classID)
            this.setState({showModal:false});
        }.bind(this));
    }


    componentDidMount(){
        StudentServices.getAllStudentsInClass(this.props.data.classID);
        ClassesService.getClass(this.props.data.classID);
    }

    componentWillMount(){

        StudentStores.on("UPDATE_CLASS_STUDENTS" , () => {
            this.data.students = StudentStores.class;
            this.setState({students:StudentStores.class});
        });

        ClassStore.on("UPDATE_CLASS" , () => {
            this.setState({classInformation:ClassStore.class});
        });
    }

    renderTableBody(){

        var tBody = [];


        for(var idx = 0; idx < this.state.students.length; idx++ )
        {
            var student = this.state.students[idx];

            if(AuthneticationStore.hasCreatePermissions())
            {
                tBody.push(<tr>
                    <td>{<Link className="text-right" to={'student/profile/'+student.uid}>{student.getName()}</Link>}</td>
                    <td>{student.lastLogin}</td>
                    <td>{student.username}</td>
                    <td>{student.password}</td>
                    <td className="text-right">
                        <button type="button" onClick={this.showComfirmation.bind(this , student.uid)}className="btn btn-icon command-delete waves-effect waves-circle" data-row-id="10253"><span className="zmdi zmdi-delete"></span></button>
                    </td>
                </tr>);

            }
            else
            {
                tBody.push(<tr><td>{student.getName()}</td><td>{student.username}</td><td>{student.password}</td></tr>);
            }

        }

        return tBody;
    }

    handelDownload(){
        //(new Download()).export_table_to_csv();
        if (this.state.classInformation != undefined){
            this.PDFgen.generateClassPDF(this.state.classInformation.name, this.state.classInformation.students);
        }
    }

    handelSave(){
        ClassesService.addStudents(this.data.students , this.props.data.classID).then(function(){
            this.data = {};
            StudentServices.getAllStudentsInClass(this.props.data.classID);
            this.setState({ isList: !this.state.isList });
        }.bind(this));
    }

    renderActions(){

        const downloadCSV = <button  onClick={this.downloadCSV.bind(this)} className="btn    m-t-0 btn-primary b-btn-icon-text waves-effect pull-right"><i className="palette-White text zmdi zmdi-download"></i>  <FormattedMessage id={ String("ui-425")} defaultMessage={ "Download Report" } /></button>;


        const download = <button onClick={this.handelDownload.bind(this)} className="btn  btn-primary b-btn-icon-text waves-effect"><i className="palette-White text zmdi zmdi-download"></i>  <FormattedMessage id="ui-2128" defaultMessage="Download Student Logins" /></button>
        const edit = <button onClick={ ()=> this.setState({ isList: !this.state.isList })} className="btn  btn-primary b-btn-icon-text waves-effect"><i className="palette-White text zmdi zmdi-plus-circle"></i>  <FormattedMessage id={ String("ui-865")} defaultMessage={ "Add Students" } /></button>


        if(!AuthneticationStore.hasCreatePermissions())
        {
            return (<div className="pull-right"></div>);
        }

        return (<div className="pull-right">{edit}&nbsp;{download}&nbsp;{downloadCSV}</div>);
    }

    handleEdit(){
        this.setState({editUser:true});
    }

    handleCancelEdit(){
        this.setState({editUser:false});
    }

    downloadCSV(){
        (new Download()).export_table_to_csv(null , "Class list");
    }

    render(){

        const EditSubPanel = !this.state.isList ? AssignStudents.component :  Row;


        let removeHeader = null;
        if(AuthneticationStore.hasCreatePermissions())
        {
            removeHeader = [
               // <th  width="50"><FormattedMessage id={ 'ui-000' } defaultMessage={ 'Edit' }/></th>,
                <th  width="50"><FormattedMessage id={ 'ui-445' } defaultMessage={ 'Remove' }/></th>
                ]
        }

        return (
            <div>

                <Modal show={this.state.editUser} onHide={this.handleCancelEdit.bind(this)} bsSize="large" aria-labelledby="contained-modal-title-lg">
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="p-10">
                            <StudentEdit  teacher={this.state.staffMember} onCreated={this.handleCancelEdit.bind(this)}/>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal show={this.state.showModal} onHide={this.close.bind(this)}>
                    <Modal.Header>
                        <Modal.Title><FormattedMessage id={ 'ui-430' } defaultMessage={ 'Remove Class' }/></Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <FormattedMessage id={ 'ui-667' } defaultMessage={ 'Are You Sure' }/>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button onClick={this.close.bind(this)}><FormattedMessage id={ 'ui-41' } defaultMessage={ 'Cancel' }/></Button>
                        <Button  onClick={this.removeStudent.bind(this)} bsStyle="primary"><FormattedMessage id={ 'ui-445' } defaultMessage={ 'Remove' }/></Button>
                    </Modal.Footer>

                </Modal>
                <Panel collapsible expanded={this.state.isList}>
                    <div className="pmb-block p-0 ">
                            <div className="row">
                                <div className="col-sm-12 actionBar hidden-xs">
                                    {this.renderActions()}
                                </div>
                            </div>
                    </div>
                     <div className="p-20">
                         <Row>
                            <Table id="student-list" condensed striped responsive bordered>
                                <thead>
                                    <tr>
                                        <th><FormattedMessage id={ 'ui-14' } defaultMessage={ 'Name' }/></th>
                                        <th><FormattedMessage id={ 'ui-13' } defaultMessage={ 'Login' }/></th>
                                        <th><FormattedMessage id={ 'ui-578' } defaultMessage={ 'Username' }/></th>
                                        <th><FormattedMessage id={ 'ui-23' } defaultMessage={ 'Password' }/></th>
                                        {removeHeader}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderTableBody()}
                                </tbody>
                            </Table>
                         </Row>
                    </div>
                </Panel>
                <Panel collapsible expanded={!this.state.isList}>
                    <div className="pmb-block p-t-0 p-b-0 m-b-0">
                        <div className="pmbb-header">
                            <h4><FormattedMessage id={ 'ui-903' } defaultMessage={ 'Create New Students' }/></h4>
                        </div>
                        <EditSubPanel data={this.data}/>
                    </div>
                    <br></br>
                    <br></br>
                    <div className="pmb-block p-t-0">
                        <Row>
                            <ButtonToolbar>
                                <Col sm={4} className="pull-right p-0"><Button onClick={this.handelSave.bind(this)} className="btn-block btn-success"><FormattedMessage id={ 'ui-336' } defaultMessage={ 'Save' }/></Button></Col>
                                <Col sm={4} className="pull-right p-0"><Button className="btn-block btn-gray" onClick={ ()=> this.setState({ isList: !this.state.isList })} ><FormattedMessage id={ 'ui-41' } defaultMessage={ 'Cancel' }/></Button></Col>
                            </ButtonToolbar>
                        </Row>
                    </div>
                </Panel>
             </div>
        );
    }
}





export default {
    name: <FormattedMessage id={ 'ui-857' } defaultMessage={ 'Students' }/>,
    component: AboutPanel
}


// WEBPACK FOOTER //
// ./src/components/profile/profile-tabs/student-class-panel.js